/**
 * @module lib/symbolAccess
 * @summary Symbol-library access password (UX gate for non-managers).
 * @description // HAZARD: plaintext in localStorage — a UX gate, not security.
 *   Default password is '1234' (matches the original). Managers/super-admins
 *   bypass it entirely.
 * @ported-from JCC PFD Engineering Tool v1.1.html lines 5243-5310.
 */
import { KEYS } from './storage';

export function getSymbolPassword(): string {
  return localStorage.getItem(KEYS.symbolPwd) || '1234';
}

export function setSymbolPassword(pwd: string): void {
  localStorage.setItem(KEYS.symbolPwd, pwd);
}

/** Change the password. Returns an error message, or null on success. */
export function changeSymbolPassword(current: string, next: string, confirm: string): string | null {
  if (current !== getSymbolPassword()) return 'Current password is incorrect.';
  if (!next) return 'New password cannot be empty.';
  if (next !== confirm) return 'New passwords do not match.';
  setSymbolPassword(next);
  return null;
}
